var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.319824H7.2C2.604 0.319824 0 2.92383 0 7.51982V20.1199C0 24.7158 2.604 27.3198 7.2 27.3198H19.8121C24.408 27.3198 27 24.7158 27 20.1199V7.51982C27 2.92383 24.408 0.319824 19.8121 0.319824Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0475 12.353V17.9797C19.0475 20.0897 18.3442 20.793 16.2342 20.793H10.6075C8.49752 20.793 7.79419 20.0897 7.79419 17.9797V12.353H19.0475Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1224 10.2431V10.9464C20.1224 11.7201 19.7496 12.3531 18.7157 12.3531H8.1657C7.0896 12.3531 6.75903 11.7201 6.75903 10.9464V10.2431C6.75903 9.46943 7.0896 8.83643 8.1657 8.83643H18.7157C19.7496 8.83643 20.1224 9.46943 20.1224 10.2431Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.1887 8.83627H9.30631C9.06717 8.57604 9.07421 8.17514 9.32741 7.92194L10.3261 6.9232C10.5864 6.66297 11.0154 6.66297 11.2756 6.9232L13.1887 8.83627Z",
    fill: "#CE2600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5692 8.83627H13.6868L15.5998 6.9232C15.8601 6.66297 16.2891 6.66297 16.5493 6.9232L17.5481 7.92194C17.8013 8.17514 17.8083 8.57604 17.5692 8.83627Z",
    fill: "#CE2600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.2881 12.353V15.9682C11.2881 16.5308 11.907 16.8614 12.3783 16.559L13.0394 16.1229C13.2786 15.9682 13.581 15.9682 13.8131 16.1229L14.4391 16.5449C14.9033 16.8544 15.5292 16.5238 15.5292 15.9611V12.353H11.2881Z",
    fill: "#CE2600"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.6ee3ce1567a8e098f2f0eeb37a40d299.svg";
export { ForwardRef as ReactComponent };